export const PRINTER_DEVICE_TYPE_SELECT_ID = 'device_type';
export const DEVICE_TYPE_SELECT_ID = 'device_type';
export const MANUFACTURER_SELECT_ID = 'manufacturer';
export const MODEL_SELECT_ID = 'model';
export const PAPER_TYPE_SELECT_ID = 'paper_type';
export const BUNDLE_SELECT_ID = 'bundle-select';